<template>
  <div class="model-component">
    <h2 class="title">{{ title }}</h2>
    <div v-if="title === '产品型号'" class="tabs">
      <ul>
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: activeTab === tab }"
          @click="changeTab(tab)"
        >
          {{ tab }}
        </li>
      </ul>
    </div>
    <div style="height: 40px"></div>

    <div class="system-info" v-if="systemInfo">
      <span class="system-info-left">{{ systemInfo.split("：")[0] }}：</span>
      <span class="system-info-right">{{ systemInfo.split("：")[1] }}</span>
    </div>

    <div class="image-container">
      <img
        :src="imageSrc"
        alt="消防车图片"
        class="fire-truck-image"
        :key="gifKey"
      />
    </div>

    <div class="description-wrapper" v-if="description">
      <img class="yinLeft" src="@/assets/home/yinLeft.png" alt="yinLeft" />
      <p class="description">{{ description }}</p>
      <img class="yinRight" src="@/assets/home/yinRight.png" alt="yinRight" />
    </div>
    <div style="height: 40px" v-if="description && models.length"></div>
    <div class="buttons">
      <button
        v-for="(model, index) in models"
        :key="index"
        :class="{ active: selectedModel === model.name }"
        @click="selectModel(model)"
      >
        <img :src="getModelImage(model.name)" alt="图标" />
        {{ model.name }}
      </button>
    </div>
    <div
      class="guiGe"
      v-if="
        currentSource === 'product_lie_13' ||
        currentSource === 'product_lie_13_1' ||
        currentSource === 'product_lie_13_2' ||
        currentSource === 'product_lie_14'
      "
    >
      <h2 class="title">规格参数</h2>
      <ul class="spec-list" v-if="activeTab == 'ZF-E2000-Q AIBox/Box'">
        <li v-for="(item, idx) in specList" :key="idx">
          <span class="spec-key">{{ item.key }}</span>
          <template v-if="item.value1 !== item.value">
            <span class="spec-value1">{{ item.value }}</span>
            <span class="spec-value1">{{ item.value1 }}</span>
          </template>
          <span class="spec-value" v-else>{{ item.value }}</span>
        </li>
      </ul>
      <ul class="spec-list" v-else>
        <li v-for="(item, idx) in specList" :key="idx">
          <span class="spec-key">{{ item.key }}</span>
          <span class="spec-value">{{ item.value }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import eventBus from "@/eventBus"; // 新增：引入事件总线
export default {
  name: "ModelComponent",
  data() {
    return {
      title: "",
      systemInfo:
        "系统组成：汽车底盘、容罐、泵组、空压机、带压系统、无人机系统、自动寻火系统、无人驾驶系统", // 确保内容中包含冒号
      imageSrc: "https://hr2.chnsoft.com.cn/img/fireTruck.png", // 替换为实际图片路径
      description:
        "压缩空气泡沫智能消防车融合压缩空气泡沫供给系统、底盘与上装系统、自动驾驶系统、自动寻火系统、无人驾驶系统、无人机系统、车辆全息感知系统及控制与无线传输系统打造的一款智能消防设备，实现区域内消防车自动驾驶、运行状态全面感知、火源自动定位、自动灭火等一系列消防工作。",
      models: [
        { name: "DFT-M01-V20 压缩空气泡沫智能消防车" },
        { name: "DFT-M02-V10 涡扇炮智能消防车" },
      ],
      selectedModel: "D51型号", // 初始化为一个空字符串
      currentSource: "", // 用于存储当前的 source 参数
      tabs: [],
      activeTab: "空海一体智能无人艇",
      specList: [
        { key: "CPU", value: "国产高性能处理器" },
        { key: "内存", value: "板载双通道UDIMM内存最大支持32GB" },
        { key: "显存", value: "8GB" },
        { key: "网络", value: "6路10/100/1000M自适应网络" },
        { key: "SATA接口", value: "4路SATA 3.0" },
        { key: "AI算力", value: "384TOPS@INT8，192TFLOPS@FP16" },
        { key: "功耗", value: "≤180W" },
        { key: "储存温度", value: "-40℃ ~ +80℃，5% ~ 95% RH" },
        { key: "PCIE接口", value: "丰富的PCIE扩展接口" },
        { key: "USB接口", value: "支持8路USB 3.0接口" },
        {
          key: "工作温度",
          value: "商业级 0 ~ 45℃，工业级 -45℃ ~ +85℃，5% ~ 95% RH",
        },
      ],
      gifKey: 0,
    };
  },
  watch: {
    $route(to, from) {
      this.gifKey += 1; // 每次路由变化时，更新 key
      // 其他路由变化时的逻辑...
    },
    // 监听 URL 的变化
    "$route.fullPath": {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        // if (source !== this.currentSource) {
        this.currentSource = source;
        this.updateMain(source);
        // }
      },
    },
  },
  mounted() {
    const selectedText = localStorage.getItem("selectedText");
    if (selectedText) {
      const model = this.models.find((m) => m.name === selectedText);
      if (model) {
        this.selectModel(model);
      }
    }
    if (!this.selectedModel && this.models.length > 0) {
      this.selectModel(this.models[0]); // 默认选中 models 的第一个项
    }
  },
  methods: {
    // 新增：给 URL 加上时间戳，避免缓存
    cacheBust(url) { // 添加时间戳参数，防止浏览器缓存
      if (!url) return ""; // URL为空时返回空字符串
      const sep = url.includes("?") ? "&" : "?"; // 根据URL是否已有查询参数确定分隔符
      return `${url}${sep}v=${Date.now()}`; // 返回带时间戳的URL
    },
    // 新增：统一设置图片并更新 key 强制重新渲染 <img :key="gifKey" />
    setImage(url) {
      this.imageSrc = this.cacheBust(url);
      this.gifKey += 1;
    },

    updateMain(source) {
      this.title = "";
      this.systemInfo = "";
      this.imageSrc = ""; // 替换为实际图片路径
      this.description = "";
      switch (source) {
        case "product_lie_1":
          this.imageSrc = "";
          // 双机系列
          this.title = "D51型号";
          this.selectedModel = "D51型号";
          this.systemInfo =
            "适配无人机：一架DJI Mavic 3/Matrice 4行业系列、一架DJI Matrice 350 RTK";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/D51.gif"; // 替换为实际图片路径
          this.description = "";
          this.models = [{ name: "D51型号" }, { name: "D55型号" }];
          break;
        case "product_lie_2":
          this.title = "V350型号";
          this.systemInfo = "适配无人机：一架DJI Matrice 350 RTK";
          this.imageSrc = "";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/V350.gif"; // 替换为实际图片路径
          this.description = "";
          this.selectedModel = "V350型号";
          this.models = [
            // { name: "V140型号" },
            // { name: "V130型号" },
            { name: "V350型号" },
            { name: "V232型号" },
            { name: "V400型号" },
          ];
          break;
        case "product_lie_3":

                    this.title = "C350型号";
          this.systemInfo = "适配无人机：一架DJI Matrice 350 RTK";
          this.imageSrc = "";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/350.gif"; // 替换为实际图片路径
          this.description = "";
          this.selectedModel = "C350型号";
          this.models = [
            // { name: "C140型号" },
            // { name: "C130型号" },
            { name: "C350型号" },
            { name: "C400型号" },
          ];
          break;
        case "product_lie_4":
          this.imageSrc = "";
          this.title = "VF7型号";
          this.systemInfo = "适配无人机：一架龙鱼Standard";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/垂起.gif"; // 替换为实际图片路径
          this.description = "";
          this.models = [
            // { name: 'VF7' },
          ];
          break;
        case "product_lie_5":
          this.imageSrc = "";
          this.title = "WF30型号";
          this.systemInfo = "适配无人机：一架DJI FlyCart30";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/大载重.gif"; // 替换为实际图片路径
          this.description = "";
          this.models = [];
          break;
        case "product_lie_5_1":
          this.title = "IAS-D441";
          this.systemInfo = "";
          this.imageSrc = "";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/D441.gif"; // 替换为实际图片路径
          this.description = "";
          this.models = [];
          break;
        case "product_lie_6":
          this.imageSrc = "";
          this.title = "移动航空站";
          this.systemInfo = "适配无人机：一架DJI Matrice 350 RTK";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/YD.gif"; // 替换为实际图片路径
          this.description =
            "移动航空站创新融合无人机与车载技术，打造高效、灵活的空中作业解决方案。产品突破传统续航限制，通过智能载车平台实现无人机全域机动部署，适应复杂地形与越野环境。配备自主跟随系统及车载操控终端，可实时传输高清影像，动态掌控全局作业，大幅提升应急响应、巡检及勘察效率，为多场景任务提供全天候、全地形的可靠支持。";
          this.models = [];
          break;
        case "product_lie_7":
          this.imageSrc = "";
          this.title = "无人装备指挥车";
          this.systemInfo = "适配无人机：1-4架DJI Matrice 350 RTK 或 Matrice 400无人机";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/指挥车.gif"; // 替换为实际图片路径
          this.description =
            "无人机应急移动指挥系统深度融合载车平台、5G通信、链路中继、AI数据分析及多机协同控制技术，打造“侦-控-判-指”一体化的智能指挥平台。系统支持无人机集群化作业与实时图像回传，通过车载指挥终端实现前线侦察、数据融合、指令同步及跨域调度，满足复杂环境下快速响应与精准决策需求。  ";
          this.models = [];
          break;
        case "product_lie_8":
          this.imageSrc = "";
          this.title = "DFT-M01-V20 压缩空气泡沫智能消防车";
          this.selectedModel = "DFT-M01-V20 压缩空气泡沫智能消防车";
          localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
          this.systemInfo =
            "系统组成：车底盘、容罐、泵组、空压机、举升系统、无人机系统、自动寻火系统、无人驾驶系统";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/压缩空气泡沫智能消防车.gif"; // 替换为实际图片路径
          this.description =
            "压缩空气泡沫智能消防车是融合压缩空气泡沫供给系统、底盘与上装系统、自动驾驶系统、自动寻火系统、车辆无人机系统、车辆全息感知系统及控制与无线传输系统打造的一款智能消防设备，实现区域内消防车自动驾驶、运行状态全面感知、火源自动定位、自动灭火等一系列消防功能。";
          this.models = [
            { name: "DFT-M01-V20 压缩空气泡沫智能消防车" },
            { name: "DFT-M02-V10 涡扇炮智能消防车" },
          ];
          break;
        case "product_lie_9":
          this.imageSrc = "";
          this.title = "陆空协同应急处置机器人";
          this.selectedModel = "DFT-M01-V20 压缩空气泡沫智能消防车";
          this.systemInfo =
            "系统组成：自动驾驶机器人底盘、燃油/电力动力系统、系留无人机机场、高压细水雾系统、细水雾炮系统";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/50.gif"; // 替换为实际图片路径
          this.description =
            "陆空协同应急处置机器人由机器人底盘系统、无人机系统、高压细水雾系统、细水雾炮系统组成。产品通过细水雾炮实现远距离、大面积喷射细水雾覆盖火焰，充分利用细水雾高效吸热、极速降温、稀释氧气、局部窒息、阻隔热辐射，以及通过系留无人机将1230灭火剂定点喷射，对高处火点进行局部降温保护并实时监控现场火情。";
          this.models = [];
          break;
        case "product_lie_8_1":
          this.imageSrc = "";
          this.title = "陆空协同智能巡视机器人";
          // this.selectedModel = 'DFT-M01-V20 压缩空气泡沫智能消防车'
          this.systemInfo =
            "系统组成：自动灭火机器人履带底盘、细水雾炮、无人机航空站、自动水管电缆卷盘		";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/M02智能巡视机器人.gif"; // 替换为实际图片路径
          this.description =
            "陆空协同智能巡视机器人，通过履带底盘、无人机巡检系统及自动寻火探测技术，实现远程高效精准灭火，保障人员与设备安全。";
          this.models = [];
          break;
        case "product_lie_8_2":
          this.imageSrc = "";
          this.title = "室内应急处置机器人";
          // this.selectedModel = 'R01室内应急处置机器人'
          this.systemInfo =
            "系统组成：升降双光云台、激光SLAM导航模块、高精度定位底盘、消防处置系统、自动充电系统。";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/R01室内应急处置机器人.gif"; // 替换为实际图片路径
          this.description =
            "室内应急处置机器人体积小巧，具备室内自动导航定位、火源定位、应急处置等功能，可穿梭在室内复杂环境中，对室内设施进行巡检、灭火等综合应用。";
          this.models = [];
          break;
        case "product_lie_10":
          this.imageSrc = "";
          this.title = "产品型号";
          this.selectedModel = "T160";
          this.systemInfo =
            "系统组成：船体、自主航行系统、远程通讯系统、无人机自动机场、多样化作业单元、综合控制系统";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/水上智能航空站.gif"; // 替换为实际图片路径
          this.description =
            "革新水域作业模式，自主导航精准避障，超长续航无惧复杂水域。无人机与无人船智能协同，空中广域扫描污染/热源，水面同步采集水质/声纳数据，构建立体监控网络。全面赋能环保巡查、应急救援、海上巡检，以全流程自动化替代高危人工作业，树立安全、高效、智能化的水域管理新标杆。";
          this.models = [];
          this.activeTab = "空海一体智能无人艇";
          localStorage.setItem("TeDianBgProName", "水上智能航空站");
          this.tabs = [
            "空海一体智能无人艇",
            "T750区域警戒巡逻无人艇",
            "T160/T240多功能水面无人船",
            "T130测流无人船",
            "T095水面采样监测无人船",
            "电动遥控救生圈",
          ];
          break;

        case "product_lie_13":
          this.imageSrc = "";
          this.title = "机载智能大脑";
          this.systemInfo = "适配无人机：DJI M350 RTK（支持定制机型）";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/机载智能大脑.gif"; // 替换为实际图片路径
          this.description =
            "扩展多类型通信链路，丰富的外部接口，具备全国产化高性能ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人机集控飞行系统中的态势感知、自主决策自主执行和数据运算处理软硬一体化工业级智能体。";
          this.models = [];
          this.activeTab = "";
          this.tabs = ["机载智能大脑"];
          this.specList = [
            { key: "无人机适配", value: "DJI Matrice 400/350RTK/支持定制机型" },
            { key: "飞行控制", value: "自主航线飞行、手动控制飞行、智能避障" },
            {
              key: "图像处理",
              value: "目标识别、目标定位、目标锁定跟踪（选配）",
            },
            { key: "无线通信", value: "支持定制频率" },
            { key: "重量", value: "700g" },
            { key: "工作环境温度", value: "-20℃ ~ 50℃" },
            { key: "机载算力", value: "48TOPS@INT8，24TOPS@FP16" },
            { key: "激光SLAM", value: "20万点/秒（选配）" },
          ];
          break;
        case "product_lie_13_1":
          this.imageSrc = "";
          this.title = "产品型号";
          this.systemInfo = "";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/ZFE2000_new.png"; // 替换为实际图片路径
          this.description =
            "采用车（船）规制通信链路及感知、控制接口，具备全国产化高性能ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人车（船）自主态势感知、自主决策自主执行和数据运算处理的软硬一体化车（船）级智能体。";
          this.models = [];
          this.activeTab = "ZF-E2000-Q AIBOX车（船）载智能大脑";
          this.tabs = [
            "ZF-E2000-Q AIBOX车（船）载智能大脑",
            "ZF-D2000-Q AIBOX车（船）载智能大脑",
            "ZF-3588车（船）载智能大脑",
          ];
          this.specList = [
            { key: "CPU", value: "国产高性能处理器" },
            { key: "内存", value: "板载LPDDR4 8G全国产内存" },

            { key: "网络", value: "2路10/100/1000M自适应网络" },
            { key: "存储", value: "最大支持1T" },
            { key: "AI算力", value: "48TOPS@INT8、24TFLOPS@FP16" },
            { key: "功耗", value: "≤30W" },
            { key: "储存温度", value: "-40℃ ~ +105℃，5% ～ 95% RH" },
            {
              key: "接口",
              value:
                "GPIO\\CAN\\RS232\\RS485\\RJ45\\USB\\DP\\TRS\\T-Flash，支持定制",
            },

            {
              key: "工作温度",
              value: "-40℃ ~ +105℃，5% ～ 95% RH",
            },
          ];
          break;

        case "product_lie_13_2":
          this.imageSrc = "";
          this.title = "ZF-C200边缘计算终端";
          this.systemInfo = "";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png"; // 替换为实际图片路径
          this.description =
            "ZF-C200全国产化边缘计算终端以“自主创新、超强算力、极致能效”为核心设计理念，深度融合算力服务领域的前沿技术与国产化硬核创新成果，从处理器、操作系统到算力板卡全栈自主可控，搭载384TOPS@INT8旗舰级AI算力与≤180W高能效设计，为工业物联网、智能边缘计算、多模态AI推理等高复杂度场景提供安全可靠、性能卓越的算力基座。";
          this.models = [];
          this.activeTab = "";
          this.tabs = [];
          this.specList = [
            { key: "CPU", value: "国产高性能处理器" },
            { key: "内存", value: "板载双通道UDIMM内存最大支持32GB" },
            { key: "显存", value: "8GB" },
            { key: "网络", value: "6路10/100/1000M自适应网络" },
            { key: "SATA接口", value: "4路SATA 3.0" },
            { key: "AI算力", value: "384TOPS@INT8、192TFLOPS@FP16" },
            { key: "功耗", value: "≤180W" },
            { key: "储存温度", value: "-40℃ ~ +80℃，5% ～ 95% RH" },
            { key: "接口", value: "支持8路USB 3.0 接口、丰富的PCIE扩展接口" },
            {
              key: "工作温度",
              value: "商业级 0 ~ 45℃，工业级 -45℃ ～ +85℃，5% ～ 95% RH",
            },
          ];
          break;
        // case 'product_lie_14':
        //   this.imageSrc = '';
        //   this.title = '产品型号';
        //   this.systemInfo = '';
        //   this.imageSrc = 'https://hr2.chnsoft.com.cn/img/ZF-A400 算力板卡.png'; // 替换为实际图片路径
        //   this.description = '作为自主创新战略的深度践行者，智能算力板卡以全栈自主可控为核心设计理念，深度融合算力服务领域的前沿技术与尖端成果，为人工智能、边缘计算、大规模数据中心等高复杂度场景提供安全、高效、可扩展的算力解决方案。';
        //   this.models = [
        //   ];
        //   this.activeTab = 'ZF-A400 算力板卡';
        //   this.tabs = ['ZF-A400 算力板卡', 'ZF-E2000-Q AIBox/Box', 'ZF-D2000 AIBox', 'ZF-3588 AIBox'];
        //   this.specList = [
        //     { key: '计算单元数量', value: '120组计算单元' },
        //     { key: '神经元数量', value: '100万个' },
        //     { key: '神经突触', value: '1亿个' },
        //     { key: 'AI算力', value: '192TOPS@INT8 96TFLOPS@FP16' },
        //     { key: '操作系统', value: 'Ubuntu、CentOS、KylinOS 等' },
        //     { key: '支持框架', value: 'DNN：TensorFlow、Pytorch、PaddlePaddle、Caffe、MxNet、Keras、ONNX 等\nSNN：Neuron 等' },
        //     { key: '支持模型', value: 'DNN：Res net、Inception、VGG、Mobile net、Yo lo、SSD、Squeezenet、Senet、DenseNet\nSNN：Microcircuit 等' },
        //   ];
        //   break;
        case "product_lie_14":
          this.imageSrc = "";
          this.title = "ZF-S5000算力服务器";
          this.systemInfo = "";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/%E4%BA%91%E7%AB%AF%E7%AE%97%E5%8A%9B%E6%9C%8D%E5%8A%A1%E5%99%A8%402x.webp"; // 替换为实际图片路径
          this.description =
            "ZF-S5000全国产化高性能算力服务器以“自主可控、极致算力、全域扩展”为核心设计理念，深度融合前沿技术与国产化硬核创新成果，从处理器、计算板卡到系统生态全链路实现自主可控，搭载1344TOPS@INT8与672TFLOPS@FP16超强AI算力，专为大规模AI推理、高性能计算、智能计算中心等高密度场景打造。";
          this.models = [];
          this.activeTab = "";
          this.tabs = [];
          this.specList = [
            { key: "处理器", value: "国产高性能处理器" },
            { key: "计算卡", value: "最大支持7槽位" },
            { key: "内存", value: "最大容量32G" },
            { key: "储存", value: "512~1T" },
            { key: "网络接口", value: "4路千兆以太网接口" },
            { key: "AI算力", value: "1344TOPS@INT8、672TFLOPS@FP16" },
            { key: "电源", value: "双路500W自带冗余切换电路" },
            { key: "扩展插槽", value: "丰富的VPX扩展接口" },
            { key: "接口", value: "4路串口，8路USB3.0，4路SATA，3路CAN" },
            { key: "工作温度", value: "0℃ ~ 35℃" },
          ];
          break;

        case "product_lie_15":
          this.imageSrc = "";
          this.title = "系留供电装置";
          this.systemInfo = "适配无人机：DJI M350 RTK（机型可定制）";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/系留.gif"; // 替换为实际图片路径
          this.description =
            "系留供电装置具备坚固耐用、运行稳定、功能丰富、携带便捷等特点，通过复合线缆为无人机提供不低于8小时的稳定供电，最高作业高度可达百米，解决无人机长时间滞空作业难题，突破无人机续航限制。";
          this.models = [];
          break;
        case "product_lie_16":
          this.imageSrc = "";
          this.title = "无人装备便携地面站";
          this.systemInfo = "适配无人机：支持大疆全系行业级无人机";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/JKFX.gif"; // 替换为实际图片路径
          this.description =
            "无人装备便携地面站采用拉杆箱式设计，性能稳定、坚固耐用、携带便捷、机动性强，作业时不受环境约束。支持适配绝大多数无人机品牌与类型，能够对多台无人机进行集中管控，具有集群化、智能化应用特点，是一套适用于各行业的无人机单兵便携飞行系统。";
          this.models = [];
          break;
        case "product_lie_17":
          this.imageSrc = "";
          this.title = "无人装备驾控台";
          this.systemInfo =
            "系统组成：国产化工作站、多屏显示器、飞控操作杆、飞行座椅";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/JK.gif"; // 替换为实际图片路径
          this.description =
            "无人装备驾控台是无人机集控飞行解决方案的控制中心节点。部署在指挥调度中心，对整个系统内的各类资源拥有执行调配和管理权限，包括常态化区域内状态管控、临时执勤等任务的制定和下发，远程实时操控任务无人机以及无人机实时信息的反馈及管理等。";
          this.models = [];
          break;
        case "product_lie_18":
          this.imageSrc = "";
          this.title = "AMS-400-V112 机载任务系统";
          this.systemInfo = "适配无人机：DJI M350 RTK（支持定制机型）";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/AMS400V112.png"; // 替换为实际图片路径
          this.description =
            "机载任务系统便捷小巧、一体集成，以实时计算为核心。具备实时图像识别与精确定位能力，让目标识别与捕捉更加精准；集成自动飞行算法，可确保无人机作业精准高效，无论是自主航线飞行还是手动操控皆游刃有余。";
          this.models = [];
          break;
        default:
          // 默认处理逻辑（如果需要）
          break;
      }
    },
    getModelImage(modelName) {
      if (modelName === "T160") {
        return "https://hr2.chnsoft.com.cn/img/T160多功能水面无人船.png"; // 动态图片路径
      }
      if (modelName === "T240") {
        return "https://hr2.chnsoft.com.cn/img/T240多功能水面无人船.png"; // 动态图片路径
      }
      if (modelName === "V140型号") {
        return "https://hr2.chnsoft.com.cn/img/V140.png"; // 动态图片路径
      }
      if (modelName === "V130型号") {
        return "https://hr2.chnsoft.com.cn/img/V130.png"; // 动态图片路径
      }
      if (modelName === "V350型号") {
        return "https://hr2.chnsoft.com.cn/img/V350.png"; // 动态图片路径
      }
      if (modelName === "V232型号") {
        return "https://hr2.chnsoft.com.cn/img/V232.png"; // 动态图片路径
      }
      if (modelName === "C140型号") {
        return "https://hr2.chnsoft.com.cn/img/C140.png"; // 动态图片路径
      }
      if (modelName === "C130型号") {
        return "https://hr2.chnsoft.com.cn/img/C130.png"; // 动态图片路径
      }
      if (modelName === "C350型号") {
        return "https://hr2.chnsoft.com.cn/img/C350.png"; // 动态图片路径
      }
      if (modelName === "V400型号") {
        return "https://hr2.chnsoft.com.cn/img/V400.png"; // 动态图片路径
      }
      if (modelName === "C400型号") {
        return "https://hr2.chnsoft.com.cn/img/C400.png"; // 动态图片路径
      }
      if (modelName === "D51型号" || modelName === "D55型号") {
        return "https://hr2.chnsoft.com.cn/img/D51Small.png"; // 动态图片路径
      }
      return "https://hr2.chnsoft.com.cn/img/fireTruSmall.png"; // 默认图片路径
    },
    selectModel(model) {
      // console.log("Selected model:", model);
      this.selectedModel = model.name;

      // 立即清空上一个图片并强制重渲染
      this.imageSrc = "";
      this.gifKey += 1;

      // 根据选中的型号更新页面内容（用 setImage 替代直接赋值）
      if (model.name === "DFT-M01-V20 压缩空气泡沫智能消防车") {
        this.systemInfo =
          "系统组成：车底盘、容罐、泵组、空压机、举升系统、无人机系统、自动寻火系统、无人驾驶系统";
        localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
        eventBus.$emit("change-tab", model.name);
        this.title = model.name;
        this.setImage(
          "https://hr2.chnsoft.com.cn/img/压缩空气泡沫智能消防车.gif"
        ); // 使用 setImage 带时间戳，避免缓存
        this.description =
          "压缩空气泡沫智能消防车是融合压缩空气泡沫供给系统、底盘与上装系统、自动驾驶系统、自动寻火系统、车辆无人机系统、车辆全息感知系统及控制与无线传输系统打造的一款智能消防设备，实现区域内消防车自动驾驶、运行状态全面感知、火源自动定位、自动灭火等一系列消防功能。";
      } else if (model.name === "DFT-M02-V10 涡扇炮智能消防车") {
        this.systemInfo =
          "系统组成：汽车底盘、容罐、泵组、消防炮系统、举升系统、自动寻火系统、无人驾驶系统";
        localStorage.setItem("TeDianBgProName", "涡扇炮智能消防车");
        eventBus.$emit("change-tab", model.name);
        this.title = model.name;
        this.setImage("https://hr2.chnsoft.com.cn/img/涡扇炮智能消防车.gif");
        this.description =
          "涡扇炮智能消防车是一款高效能消防设备，具备强力涡扇炮灭火系统，适用于大范围火灾扑救，支持远程控制与自动化操作。";
      } else if (model.name === "T160") {
        this.setImage(
          "https://hr2.chnsoft.com.cn/img/T160多功能水面无人船.png"
        );
      } else if (model.name === "T240") {
        this.setImage(
          "https://hr2.chnsoft.com.cn/img/T240多功能水面无人船.png"
        );
      } else if (model.name === "V130型号") {
        this.title = model.name;
        this.systemInfo = "适配无人机：一架DJI Mavic 3行业系列";
        this.setImage("https://hr2.chnsoft.com.cn/img/V130.gif");
      } else if (model.name === "V140型号") {
        this.title = model.name;
        this.systemInfo = "适配无人机：一架DJI Matrice 4系列";
        this.setImage("https://hr2.chnsoft.com.cn/img/V140.gif");
      } else if (model.name === "V350型号") {
        this.title = model.name;
        this.systemInfo = "适配无人机：一架DJI Matrice 350 RTK";
        this.setImage("https://hr2.chnsoft.com.cn/img/V350.gif");
      } else if (model.name === "V232型号") {
        this.title = model.name;
        this.systemInfo =
          "适配无人机：两架DJI Mavic 3/Matrice 4行业系列（一主一备）";
        this.setImage("https://hr2.chnsoft.com.cn/img/V232.gif");
      } else if (model.name === "V400型号") {
        this.title = model.name;
        this.systemInfo = "适配无人机：一架DJI Matrice 400";
        this.setImage("https://hr2.chnsoft.com.cn/img/V400_c400.gif");
      } else if (model.name === "C400型号") {
        this.title = model.name;
        this.systemInfo = "适配无人机：一架DJI Matrice 400";
        this.setImage("https://hr2.chnsoft.com.cn/img/V400_c400.gif");
      } else if (model.name === "C130型号") {
        this.systemInfo = "适配无人机：一架DJI Mavic 3行业系列";
        this.setImage("https://hr2.chnsoft.com.cn/img/C130.gif");
        this.title = model.name;
      } else if (model.name === "C140型号") {
        this.setImage("https://hr2.chnsoft.com.cn/img/C140.gif");
        this.systemInfo = "适配无人机：一架DJI Matrice 4系列";
        this.title = model.name;
      } else if (model.name === "C350型号") {
        this.setImage("https://hr2.chnsoft.com.cn/img/350.gif");
        this.systemInfo = "适配无人机：一架DJI Matrice 350 RTK";
        this.title = model.name;
      } else if (model.name === "D51型号") {
        this.setImage("https://hr2.chnsoft.com.cn/img/D51.gif");
        this.systemInfo =
          "适配无人机：一架DJI Mavic 3/Matrice 4行业系列、一架DJI Matrice 350 RTK";
        this.title = model.name;
      } else if (model.name === "D55型号") {
        this.setImage("https://hr2.chnsoft.com.cn/img/D55.gif");
        this.systemInfo = "适配无人机：两架DJI Matrice 350 RTK";
        this.title = model.name;
      }
    },
    changeTab(tab) {
      this.activeTab = tab;
      localStorage.setItem("productCode", tab);
      if (tab == "ZF-E2000-Q AIBOX车（船）载智能大脑") {
        localStorage.setItem("TeDianBgProName", "车（船）载智能大（小）脑");
      } else {
        localStorage.setItem("TeDianBgProName", tab);
      }
      // 修改：使用导入的 eventBus 发送事件
      eventBus.$emit("change-tab", tab);
      switch (tab) {
        case "空海一体智能无人艇":
          this.models = [];
          this.systemInfo =
            "系统组成：船体、自主航行系统、远程通讯系统、无人机自动机场、多样化作业单元、综合控制系统";
          this.description =
            "革新水域作业模式，自主导航精准避障，超长续航无惧复杂水域。无人机与无人船智能协同，空中广域扫描污染/热源，水面同步采集水质/声纳数据，构建立体监控网络。全面赋能环保巡查、应急救援、海上巡检，以全流程自动化替代高危人工作业，树立安全、高效、智能化的水域管理新标杆。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/水上智能航空站.gif"; // 替换为实际图片路径
          break;
        case "T750区域警戒巡逻无人艇":
          this.models = [];
          this.systemInfo = "系统组成：船体、自动驾驶系统、控制系统、通信系统";
          this.description =
            "T750区域警戒巡逻无人艇是一款具备智能化、高效性和适应性的智能水面无人装备，搭载了先进的智能控制系统，能够高效地完成对目标区域的监控和巡逻任务。";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/区域警戒巡逻无人艇.png"; // 替换为实际图片路径
          break;
        case "T160/T240多功能水面无人船":
          this.models = [{ name: "T160" }, { name: "T240" }];
          this.selectedModel = "T160"; // 默认选中 T160
          this.systemInfo = "系统组成：船体、自动驾驶系统、控制系统、通信系统";
          this.description =
            "T160/T240多功能水面无人船以江河流域、湖泊水库、近海沿岸、港口码头等流域为主要应用场景，可搭载集成水质采样器、多参数水质分析仪、侧扫声呐、ADCP、单波束测深仪等专业仪器。";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/T160多功能水面无人船.png"; // 替换为实际图片路径
          break;
        case "T130测流无人船":
          this.models = [];
          this.systemInfo = "系统组成：船体、自动驾驶系统、控制系统、通信系统";
          this.description =
            "T130测流无人船以江河湖泊、水库、海岸、码头等流域为主要应用场景，采用自主研发涵道式推进器，纯电力推进，防缠绕设计，支持倒车航行，推进器与船体底部齐平，布放与回收方便。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/wuRenChuan5.png"; // 替换为实际图片路径
          break;
        case "T095水面采样监测无人船":
          this.models = [];
          this.systemInfo = "系统组成：船体、自动驾驶系统、控制系统、通信系统";
          this.description =
            "T095 水面采样/监测无人船以河湖、水库等水域为主要应用场景，可同时搭载水质采样器和多参数水质在线监测仪，ADCP、单波束测深仪、侧扫声呐等设备。";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/T095水面采样监测无人船.png"; // 替换为实际图片路径
          break;
        case "电动遥控救生圈":
          this.models = [];
          this.systemInfo =
            "配置参数：最大施救重量 150千克 续航时间 60分钟 遥控距离 600米";
          this.description =
            "水上智能救生圈采用新型复合材料一次成型，具有重量轻、耐腐蚀、机动灵活等特点，可广泛适用于江河、湖泊、水库、海洋等不同水域，遥控技术迅速展开救援行动，能够搭载救援物资，并具备自动返航等功能。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/电动遥控救生圈.png"; // 替换为实际图片路径
          break;

        case "ZF-C200 边缘计算终端":
          this.models = [];
          this.description =
            "ZF-C200全国产化边缘计算终端以“自主创新、超强算力、极致能效”为核心设计理念，深度融合算力服务领域的前沿技术与国产化硬核创新成果，从处理器、操作系统到算力板卡全栈自主可控，搭载384TOPS@INT8旗舰级AI算力与≤180W高能效设计，为工业物联网、智能边缘计算、多模态AI推理等高复杂度场景提供安全可靠、性能卓越的算力基座。";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/ZF-C200 边缘计算终端.png"; // 替换为实际图片路径
          this.specList = [
            { key: "CPU", value: "国产高性能处理器" },
            { key: "内存", value: "板载双通道UDIMM内存最大支持32GB" },
            { key: "显存", value: "8GB" },
            { key: "网络", value: "6路10/100/1000M自适应网络" },
            { key: "SATA接口", value: "4路SATA 3.0" },
            { key: "AI算力", value: "384TOPS@INT8、192TFLOPS@FP16" },
            { key: "功耗", value: "≤180W" },
            { key: "储存温度", value: "-40℃ ~ +80℃，5% ～ 95% RH" },
            { key: "接口", value: "支持8路USB 3.0 接口、丰富的PCIE扩展接口" },
            {
              key: "工作温度",
              value: "商业级 0 ~ 45℃，工业级 -45℃ ～ +85℃，5% ～ 95% RH",
            },
          ];
          break;
        case "ZF-S5000 算力服务器":
          this.models = [];
          this.description =
            "ZF-S5000全国产化高性能算力服务器以“自主可控、极致算力、全域扩展”为核心设计理念，深度融合前沿技术与国产化硬核创新成果，从处理器、计算板卡到系统生态全链路实现自主可控，搭载1344TOPS@INT8与672TFLOPS@FP16超强AI算力，专为大规模AI推理、高性能计算、智能计算中心等高密度场景打造。";
          this.imageSrc =
            "https://hr2.chnsoft.com.cn/img/%E4%BA%91%E7%AB%AF%E7%AE%97%E5%8A%9B%E6%9C%8D%E5%8A%A1%E5%99%A8%402x.webp"; // 替换为实际图片路径
          this.specList = [
            { key: "处理器", value: "国产高性能处理器" },
            { key: "计算卡", value: "最大支持7槽位" },
            { key: "内存", value: "最大容量32G" },
            { key: "储存", value: "512~1T" },
            { key: "网络接口", value: "4路千兆以太网接口" },
            { key: "AI算力", value: "1344TOPS@INT8、672TFLOPS@FP16" },
            { key: "电源", value: "双路500W自带冗余切换电路" },
            { key: "扩展插槽", value: "丰富的VPX扩展接口" },
            { key: "接口", value: "4路串口，8路USB3.0，4路SATA，3路CAN" },
            { key: "工作温度", value: "0℃ ~ 35℃" },
          ];
          break;
        case "ZF-A400 算力板卡":
          this.models = [];
          this.description =
            "作为自主创新战略的深度践行者，智能算力板卡以全栈自主可控为核心设计理念，深度融合算力服务领域的前沿技术与尖端成果，为人工智能、边缘计算、大规模数据中心等高复杂度场景提供安全、高效、可扩展的算力解决方案。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/ZFA400.png"; // 替换为实际图片路径
          this.specList = [
            { key: "无人机适配", value: "DJI Matrice 400/350RTK/支持定制机型" },
            { key: "飞行控制", value: "自主航线飞行、手动控制飞行、智能避障" },
            {
              key: "图像处理",
              value: "目标识别、目标定位、目标锁定跟踪（选配）",
            },
            { key: "无线通信", value: "支持定制频率" },
            { key: "重量", value: "700g" },
            { key: "工作环境温度", value: "-20℃ ~ 50℃" },
            { key: "机载算力", value: "48TOPS@INT8，24TOPS@FP16" },
            { key: "激光SLAM", value: "20万点/秒（选配）" },
          ];
          break;
        case "ZF-E2000-Q AIBOX车（船）载智能大脑":
          this.models = [];
          this.description =
            "采用车（船）规制通信链路及感知、控制接口，具备全国产化高性能ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人车（船）自主态势感知、自主决策自主执行和数据运算处理的软硬一体化车（船）级智能体。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/ZFE2000_new.png"; // 替换为实际图片路径
          this.specList = [
            { key: "CPU", value: "国产高性能处理器" },
            { key: "内存", value: "板载LPDDR4 8G全国产内存" },

            { key: "网络", value: "2路10/100/1000M自适应网络" },
            { key: "存储", value: "最大支持1T" },
            { key: "AI算力", value: "48TOPS@INT8、24TFLOPS@FP16" },
            { key: "功耗", value: "≤30W" },
            { key: "储存温度", value: "-40℃ ~ +105℃，5% ～ 95% RH" },
            {
              key: "接口",
              value:
                "GPIO\\CAN\\RS232\\RS485\\RJ45\\USB\\DP\\TRS\\T-Flash，支持定制",
            },

            {
              key: "工作温度",
              value: "-40℃ ~ +105℃，5% ～ 95% RH",
            },
          ];
          break;
        case "ZF-D2000-Q AIBOX车（船）载智能大脑":
          this.models = [];
          this.description =
            "采用车（船）规制通信链路及感知、控制接口，具备全国产化高性能ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人车（船）自主态势感知、自主决策自主执行和数据运算处理的软硬一体化车（船）级智能体。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/ZFD2000_BIG.png"; // 替换为实际图片路径
          this.specList = [
            { key: "CPU", value: "国产高性能处理器" },
            { key: "内存", value: "单通道SODIMM 单条最大支持16G" },
            { key: "网络", value: "4路10/100/1000M自适应网络" },
            { key: "存储", value: "最大支持1T" },
            { key: "AI算力", value: "最大96TOPS@INT8、48TFLOPS@FP16" },
            { key: "功耗", value: "≤85W" },
            // { key: "储存温度", value: "-45℃~+105℃，5% ~ 95% RH" },
            {
              key: "接口",
              value: "RS232\\RJ45\\USB\\HDMI\\VGA\\TRS，支持定制",
            },
            { key: "工作温度", value: "-40℃~+105℃，5% ~ 95% RH" },
          ];
          break;
        case "ZF-3588车（船）载智能大脑":
          this.models = [];
          this.description =
            "采用车（船）规制通信链路及感知、控制接口，具备全国产化低功耗ARM处理器、类脑算力芯片，集成多传感器融合、人工智能算法构成无人车（船）自主态势感知、自主决策自主执行和数据运算处理的软硬一体化车（船）级智能体。";
          this.imageSrc = "https://hr2.chnsoft.com.cn/img/ZFD2000_BIG.png"; // 替换为实际图片路径
          this.specList = [
            { key: "CPU", value: "低功耗处理器" },
            { key: "内存", value: "128G" },
            { key: "网络", value: "4路10/100/1000M自适应网络" },
            { key: "存储", value: "64/128G EMMC" },
            { key: "AI算力", value: "最大96TOPS@INT8、48TFLOPS@FP16" },
            { key: "功耗", value: "25W~36W" },
            // { key: "储存温度", value: "-45℃~+105℃，5% ~ 95% RH" },
            {
              key: "接口",
              value:
                "RS232\\RS485\\CAN\\RJ45\\USB\\HDMI\\VGA\\TRS\\GPIO，支持定制",
            },
            { key: "工作温度", value: "-40℃~+85℃，5% ~ 95% RH" },
          ];
          break;

        default:
          this.models = [];
          this.description = "";
          this.imageSrc = "";
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.model-component {
  text-align: center;
  padding: 20px;
  padding-top: 80px;
  padding-bottom: 80px;
}

.title {
  font-family: PingFang SC;
  font-size: 32px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #1e242a;
}

.system-info {
  font-size: 14px;
  color: #1e242a;
  display: inline-block;
  text-align: center;
  padding: 11px 24px;
  border: 1px solid rgba(30, 36, 42, 0.2);
  border-radius: 25px;
  margin: 0px 24px 24px;
}

.system-info-left {
  /* font-weight: bold; 左侧部分样式 */
  color: #1e242a;
}

.system-info-right {
  color: #1e242a;
  opacity: 0.6;
  /* 右侧部分样式 */
}

.fire-truck-image {
  width: auto;
  height: 512px;
}

.description-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  padding: 0 18.75%;
  /* margin-bottom: 40PX; */
}

.description {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.yinLeft {
  position: absolute;
  left: calc(18.75% - 30px);
  top: 0;
  width: 20px;
  height: 16px;
  z-index: 2;
}

.yinRight {
  position: absolute;
  right: calc(18.75% - 30px);
  bottom: 0px;
  width: 20px;
  height: 16px;
  z-index: 2;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 40px;
}

button {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid rgba(30, 36, 42, 0.1);
  /* 未点击时边框为灰色 */
  background-color: white;
  color: #1e242a;
  /* 未点击时文本为黑色 */
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;
  font-size: 20px;
  /* 添加动态切换效果 */
}

button img {
  margin-right: 10px;
  /* 图片与文本之间的间距 */
  width: 52px;
  height: 40px;
}

button.active {
  border-color: #0f6bf6;
  /* 点击时边框为蓝色 */
  color: #0f6bf6;
  font-weight: bold;
  background: rgba(15, 107, 246, 0.04);
  /* 点击时文本为蓝色 */
}

button:hover {
  border-color: #0f6bf6;
  /* 悬停时边框为蓝色 */
}

.tabs {
  padding: 0 18.75%;
  margin-top: 40px;
}

.tabs ul {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  /* margin: 0 0 40PX; */
}

.tabs li {
  padding: 10px 0px;
  cursor: pointer;
  margin: 0 17px;
  background-color: transparent;
  /* 无背景色 */
  font-family: PingFang SC;
  font-size: 16px;
  
  color: #1e242acc;
  /* 未点击时文本为黑色 */
  position: relative;
  /* 为下部短线定位 */
  transition: all 0.3s ease;
  border: none;
  /* 移除边框 */
  white-space: nowrap;
}

.tabs li.active {
  color: #0f6bf6;
  font-weight: bold;
  /* 点击时文本为蓝色 */
}

.tabs li.active::after {
  content: "";
  position: absolute;
  bottom: -5px;
  /* 短线距离文本的间距 */
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  /* 短线宽度 */
  height: 2px;
  /* 短线高度 */
  background-color: #0f6bf6;
  /* 短线颜色 */
}

.tabs li:hover {
  color: #0f6bf6;
  /* 悬停时文本变为蓝色 */
}

.tab-content {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  color: #1e242a;
  line-height: 1.6;
  padding: 0 15%;
}

.spec-list {
  width: 100%;
  margin: 30px auto 0px auto;
  padding: 0;
  list-style: none;
}

.spec-list li {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  background: #fff;
  /* 白色背景 */
  margin: 0;
  /* margin为0 */
  padding: 0;
  /* padding为0 */
  border-radius: 8px;
  box-sizing: border-box;
  column-gap: 20px;
  margin-bottom: 16px;
  height: 40px;
  /* 高度40PX */
}

.spec-key,
.spec-value,
.spec-value1 {
  border-radius: 4px;
  background: #fbfbfb;
}

.spec-key {
  color: #1e242a;
  
  font-size: 14px;
  flex: 0 0 30%;
  text-align: left;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
}

.spec-value {
  color: #1e242a99;
  font-size: 15px;
  
  flex: 0 0 70%;
  text-align: left;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;

  span {
    opacity: 0.6;
  }
}

.spec-value1 {
  color: #1e242a99;
  font-size: 15px;
  
  flex: 0 0 30%;
  text-align: left;
  /* height: 40PX;
  line-height: 40PX; */
  padding-left: 20px;

  span {
    opacity: 0.6;
  }
}

.guiGe {
  padding: 0 18.75%;
  margin-top: 80px;
}

.image-container {
  /* height: 640PX; */
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 40px;
}

::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>
